module.exports = __webpack_public_path__ + "static/media/about-kovel-1.39a7bb7f.mp4";